import { CategoryEnum } from "@gtpl/shared-models/masters";
import { Column, Entity,  PrimaryGeneratedColumn, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";

@Entity('history')
export class History {

  @PrimaryGeneratedColumn("increment", { name: 'history_id' })
  historyId: number;

  @Column({
    type: 'enum',
    enum: CategoryEnum,
    nullable: false,
    default: CategoryEnum.RACK,
    name: 'category'
  })
  category: CategoryEnum;

  @Column("varchar", {
    nullable: false,
    name: "category_id",
    length:20
  })
  categoryId: string;

  @Column("text", {
    nullable: false,
    name: "assoc_rfid"
  })
  assocRfId: string;

  @Column('integer', {
    nullable: false,
    name: 'plant_id'
  })
  plantId: number;

  @Column({
    name: "expiry_date",
    type: "datetime"
  })
  expiryDate: Date;

  @Column("boolean", {
    nullable: false,
    name: "is_active",
    default:true
  })
  isActive: boolean | null;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: false,
    name: "created_user",
    length: 50
  })
  createdUser: string | null;

  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user",
    length: 50
  })
  updatedUser: string | null;

  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;

}
